import { Col, Row, Button } from 'react-bootstrap';
import { useState, useEffect, useCallback } from 'react';

import BasicSpinner from '../common/basic-spinner';
import PaginatedList from '../common/pagination';

import { fetchPublicImages } from '../../utils/fetch-helpers'

//================================================================

export default function ImagesPage(){

  const [images, setImages] = useState();

  //----------------------------------------------------------------

  const fetchImages = async (signal) => {
    setImages(await fetchPublicImages(signal));
  }

  //----------------------------------------------------------------

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchImages(signal);

    return () => {
      // Cancel the request when the component unmounts
      abortController.abort();
    };
  }, []);

  //----------------------------------------------------------------

  return(
    <>
      {!images ?
        <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
        :
        <>
          <Row className="mb-2">
            <Col className="h4 text-start">Public Images:</Col>
          </Row>
          <PaginatedList
            key='public-images'
            list={images}
            type='image'
          />
        </>
      }
    </>
  );
}
